import React from 'react';

/**
 * @typedef {Object} InfoItem
 * @property {string} key - Unique key
 * @property {React.ReactNode} label - Label (e.g., "Desc.")
 * @property {React.ReactNode} value - Value (e.g., "10%")
 */

/**
 * Props:
 * - title?: string
 * - items: InfoItem[]
 * - leading?: React.ReactNode (e.g., radio button or price)
 */
export const InfoLineUI = ({ title, items, leading }) => {
    if (!items?.length) return null;

    return (
        <div className="d-flex flex-column">
            {title && <strong className="text-primary fs-6 mb-1">{title}</strong>}

            <div className="border rounded-3 ps-3 py-2">
                <div className="row align-items-center">
                    {leading && (
                        <div className="col-auto m-0 d-flex align-items-center justify-content-start fw-bold">
                            {leading}
                        </div>
                    )}

                    <div className="col row justify-content-around align-items-center">
                        {items.map((item) => (
                            <div key={item.key} className="col-12 col-md small">
                                <span>{item.label} </span>
                                <span  className="fw-semibold">{item.value}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
